import { render, staticRenderFns } from "./supplyProportion.vue?vue&type=template&id=84ff03d4"
import script from "./supplyProportion.vue?vue&type=script&lang=js"
export * from "./supplyProportion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/devjobs/builds/JYRJr4p_y/0/supplyonline/covisint-cn-mcd/srm/mcd-srm-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84ff03d4')) {
      api.createRecord('84ff03d4', component.options)
    } else {
      api.reload('84ff03d4', component.options)
    }
    module.hot.accept("./supplyProportion.vue?vue&type=template&id=84ff03d4", function () {
      api.rerender('84ff03d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/Nutrition/baseData/supplyProportion.vue"
export default component.exports